"use client";
import QRCode from "qrcode.react";
import {useSession} from "next-auth/react";
import {useEffect, useState} from "react";
import axios from "@/lib/axios";

export default function QrCode({id, type = "event"}){
    const session = useSession();
    const [url,setUrl] = useState(false);

    useEffect(() => {

        if(session.status === "authenticated" && !url){
            if(type === "event"){
                const callRequest = axios.get('training/participant/' + id,{
                    headers : {
                        Authorization : "Bearer " + session.data.user.token
                    }
                }).then((res) => {
                    setUrl(process.env.NEXT_PUBLIC_URL + "/checked/event/"+res.data.data.code);
                })
                    .catch((err) => console.error("err",err))
            }else{
                const callRequest = axios.get('activities/participants/' + id,{
                    headers : {
                        Authorization : "Bearer " + session.data.user.token
                    }
                }).then((res) => {
                    //console.log("value code")
                    setUrl(process.env.NEXT_PUBLIC_URL + "/checked/activity/"+res.data.data.code);
                })
                    .catch((err) => console.error("err",err))
            }

        }
    },[url,session.status])

    if(!url) return <></>;

    //console.log("url", url);
    return(
        <QRCode value={url} fgColor={"#E6A900"} size={256}/>
    )
}